export default __webpack_public_path__ + "static/media/Aura-Egg__79.c7a053ac.png";